import React from "react";
import ToggleSwitch from "../common/ToggleSwitch";

const AutomationSettings = ({
  autoSyncOpportunity,
  setAutoSyncOpportunity,
  automatedOpportunitySharing,
  setAutomatedOpportunitySharing,
}) => {
  return (
    <div className="automation-section">
      <div className="automation-section-title">Automation Settings</div>
      <div className="automation-row">
        <ToggleSwitch
          label="Auto-Sync Opportunity and Co-Sell"
          value={autoSyncOpportunity}
          onChange={setAutoSyncOpportunity}
        />
        <ToggleSwitch
          label="Automated Opportunity Sharing"
          value={automatedOpportunitySharing}
          onChange={setAutomatedOpportunitySharing}
        />
      </div>
    </div>
  );
};

export default AutomationSettings;
